export default class ConfirmDialogCtrl {
  constructor ($scope, $mdDialog, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
  // constants
    var disableAccessVm = this
    const shared         = PortfolioModalSrv.getVariable()
  //variable
    disableAccessVm.idOwner = shared.idOwner
    disableAccessVm.user    = shared.user

  //methods
    disableAccessVm.disableAccess = disableAccess
    disableAccessVm.close         = close

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    function disableAccess(user){
      let header = {
        idOwner : disableAccessVm.idOwner,
        idGuest : disableAccessVm.user.idGuest
      }
      PortfolioSrv.disableUserAccess.disable(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()   
        }
      }, function (data) {
          console.log(data)
      })
    }

  }
}

ConfirmDialogCtrl.$inject = ['$scope', '$mdDialog', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv','GlobalConfig', '$cookies', '$state']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/sharedPortfolio/modals/confirmDialogCtrl.js